<template>
  <b-modal
    title="Импорт файла"
    ref="importModal"
    id="importModal"
    header-bg-variant="primary"
    header-text-variant="light"
    ok-title="Загрузить"
    cancel-title="Отмена"
    ok-variant="primary"
    :ok-disabled="!Boolean(fileToUpload)"
    @ok="onFileUpload"
  >
    <b-form-file
      class="mb-2"
      v-model="fileToUpload"
      :accept="accept"
      placeholder="Выберите файл или перетащите сюда"
      drop-placeholder="Перетащите файл сюда"
      browse-text="Открыть"
    >
    </b-form-file>
    <div v-if="isLoading" class="d-flex align-items-center">
      <b-spinner class="mr-3" variant="primary" />
      <strong>Загрузка...</strong>
    </div>
    <b-form-invalid-feedback :force-show="Boolean(uploadError)">
      {{ uploadError }}
    </b-form-invalid-feedback>
  </b-modal>
</template>

<script>

function initialState() {
  return {
    fileToUpload: null,
    isLoading: false,
    uploadError: null
  }
}

export default {
  name: 'UploadCodeModal',
  data() {
    return {
      ...initialState(),
      fileContent: null
    }
  },
  props: {
    accept: String
  },
  methods: {
    onFileUpload(event) {
      event.preventDefault()
      const reader = new FileReader()
      reader.readAsText(this.fileToUpload, 'UTF-8')
      this.isLoading = true
      this.uploadError = null
      reader.onload = (evt) => {
        this.fileContent = evt.target.result
        this.$emit('fileUploaded', this.fileContent)
        this.$refs.importModal.hide()
        Object.assign(this.$data, initialState())
      }
      reader.onerror = () => {
        this.isLoading = false
        this.uploadError = 'Ошибка загрузки файла'
      }
    }
  }
}
</script>

<style scoped>

</style>
